import type { UnderlyingHistorics } from 'components/shared/UnderlyingHistos/UnderlyingHistoModels';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient, IHttpConfig } from 'utils/http/httpClient.model';

export interface GetUnderlyingsHistoByKeys {
  getUnderlyingsHistoByIds(bloombergIds: string[]): Observable<UnderlyingHistorics>;
}

export function underlyingHistoApiConnector(http: IHttpClient): GetUnderlyingsHistoByKeys {
  return {
    getUnderlyingsHistoByIds: bloombergIds => {
      const req: IHttpConfig = {
        url: 'api/v1/underlyings/historic',
        body: {
          bloombergIds,
        },
        tryParseErrorPayload: true,
      };
      return http.postJSON<UnderlyingHistorics>(req).pipe(map(r => r.payload));
    },
  };
}
